<div class="commission__salesItem">
  <div class="box">
    <span>{{numberOfSales}}</span>
  </div>
  <div class="text">
    <p><i class="pi pi-calendar"></i> <span>{{salesDescription}}</span></p>
  </div>
</div>
